import * as React from 'react';
import * as _ from 'lodash';
import ChevronRightIcon from 'assets/images/chevron_right.svg';

type Props = {
  faultCodes: Array<any>;
  selectedFaultCode: any;
  onSelect: (faultCode: any) => void;
  t: (key: string, options?: any) => string;
  className?: string;
  showReportedTime?: boolean;
  formatDateTime?: (date: any) => string;
};

export function FaultCodesList({
  faultCodes,
  selectedFaultCode,
  onSelect,
  t,
  className,
  showReportedTime,
  formatDateTime,
}: Props) {
  return (
    <div className={className || 'search-results-fault-codes'}>
      {_.map(faultCodes, faultCode => {
        const isActive =
          selectedFaultCode &&
          selectedFaultCode.code === faultCode.code &&
          selectedFaultCode.j1939Fmi === faultCode.j1939Fmi &&
          selectedFaultCode.j1939Spn === faultCode.j1939Spn;

        const key =
          faultCode.errorType == 'j1939'
            ? `${faultCode.j1939Spn}-${faultCode.j1939Fmi}`
            : faultCode.code;

        const title =
          faultCode.errorType == 'j1939'
            ? `${t('fault_mode_j1939')}: ${faultCode.j1939Spn}-${
                faultCode.j1939Fmi
              }`
            : `${t('fault_mode_e_code')}: ${faultCode.code}`;

        return (
          <div
            className={`fault-code-item ${isActive ? 'active' : ''}`}
            key={key}
            onClick={() => onSelect(faultCode)}
          >
            {title}
            {showReportedTime && formatDateTime && (
              <div className="fault-code-list-date">
                {formatDateTime(faultCode.timeReported)}
              </div>
            )}
            <span>
              <img src={ChevronRightIcon}></img>
            </span>
          </div>
        );
      })}
    </div>
  );
}
